import classNames from 'classnames';
import { Severity } from 'Data/ViewModels/Core/Severity';
import { hasValue } from 'Lib/Any';
import './InterfaceIndicator.scss';

const InterfaceIndicator: React.FC<{ inProgress?: boolean; severity?: Severity }> = ({ inProgress, severity }) => (
  <span
    className={classNames('InterfaceIndicator', {
      'InterfaceIndicator-inProgress': inProgress,
      [`InterfaceIndicator-${severity}`]: hasValue(severity),
    })}
  />
);

export { InterfaceIndicator };
export default InterfaceIndicator;
